<div class="workflow-configurator" [formGroup]="form">
    <input
        *ngIf="area === 'CLOSING_PROCESS'"
        hamInput
        [label]="'aumico_cp_workflow_title' | i18next"
        [formControl]="form.controls['name']"
        [placeholder]="'aumico_cpmm_enter_title' | i18next"
    />

    <div class="sticky-container">
        <div *ngIf="area === 'CLOSING_PROCESS'" class="tabs">
            <ham-button
                size="sm"
                [variant]="
                    isAreaInvalid(taskTypes.GENERAL) && attemptSaveWasClickedButNotSuccessful
                        ? 'red'
                        : activeTaskType === taskTypes.GENERAL
                        ? 'primary'
                        : 'white'
                "
                (buttonClick)="setActiveType(taskTypes.GENERAL)"
            >
                {{ 'aumico_cp_general' | i18next }}
            </ham-button>
            <ham-button
                size="sm"
                [variant]="
                    isAreaInvalid(taskTypes.BALANCE_SHEET) && attemptSaveWasClickedButNotSuccessful
                        ? 'red'
                        : activeTaskType === taskTypes.BALANCE_SHEET
                        ? 'primary'
                        : 'white'
                "
                (buttonClick)="setActiveType(taskTypes.BALANCE_SHEET)"
            >
                {{ 'aumico_cp_balance_sheet' | i18next }}
            </ham-button>
            <ham-button
                size="sm"
                [variant]="
                    isAreaInvalid(taskTypes.INCOME_STATEMENT) && attemptSaveWasClickedButNotSuccessful
                        ? 'red'
                        : activeTaskType === taskTypes.INCOME_STATEMENT
                        ? 'primary'
                        : 'white'
                "
                (buttonClick)="setActiveType(taskTypes.INCOME_STATEMENT)"
            >
                {{ 'aumico_cp_income_statement' | i18next }}
            </ham-button>
        </div>

        <!-- REV-22155: mandate management has the button under the sections (see below) -->
        <div *ngIf="area !== 'MANDATE_MANAGEMENT'" class="add-section-wrapper">
            <ham-button
                class="add-section"
                size="sm"
                [outline]="false"
                variant="transparent"
                icon="assets/hamIcons/plus-outline.svg"
                (buttonClick)="addSection()"
            >
                {{ 'aumico_cpmm_add_section' | i18next }}
            </ham-button>
        </div>
    </div>

    <div *ngIf="sectionControls.length === 0 || getFilteredSectionControls(sections)?.length === 0" class="empty-state">
        <p class="no-tasks-title">{{ 'aumico_cpmm_no_tasks_title' | i18next }}</p>
        <p class="no-tasks-subtitle">{{ 'aumico_cpmm_no_tasks_subtitle' | i18next }}</p>
    </div>

    <ham-accordion
        cdkDropList
        [cdkDropListData]="getFilteredSectionControls(sections)"
        [cdkDropListOrientation]="'vertical'"
        (cdkDropListDropped)="dropSection($event)"
        class="grey-svg-icon"
    >
        <ham-accordion-item
            class="section"
            *ngFor="let section of getFilteredSectionControls(sections)"
            [formGroup]="section"
            cdkDrag
            cdkDragLockAxis="y"
            [cdkDragDisabled]="getFilteredSectionControls(sections).length <= 1"
            (cdkDragMoved)="onDragMoved($event)"
            (cdkDragEnded)="onDragEnded()"
            (click)="activeSectionIndex = originalIndexOf(section)"
            (opened)="onAccordionExpand(originalIndexOf(section))"
            (closed)="onAccordionClosed(originalIndexOf(section))"
            [isOpened]="sectionExpanded[originalIndexOf(section)]"
        >
            <ng-template cdkDragPreview>
                <div class="drag-preview">
                    {{ section.value?.name || 'aumico_cpmm_set_section_name' | i18next }}
                </div>
            </ng-template>
            <ng-template cdkDragPlaceholder>
                <div class="drag-placeholder"></div>
            </ng-template>

            <div
                class="section-name-container"
                accordion-header
                [class.invalid]="isSectionInvalid(section) && attemptSaveWasClickedButNotSuccessful"
            >
                <span cdkDragHandle class="ham-icon" (click)="$event.stopPropagation()" style="padding-right:10px">
                    <i class="dots-grid-icon gray"></i>
                </span>
                <div class="section-input">
                    <span *ngIf="!sectionNameEditMode[originalIndexOf(section)]"> {{ section.value?.name }} </span>
                    <span *ngIf="!sectionNameEditMode[originalIndexOf(section)] && section.value?.name == null">
                        {{ 'aumico_cpmm_set_section_name' | i18next }}
                    </span>

                    <input
                        *ngIf="sectionNameEditMode[originalIndexOf(section)]"
                        #sectionNameInput
                        hamInput
                        formControlName="name"
                        [placeholder]="'aumico_cpmm_set_section_name' | i18next"
                        (keydown.enter)="editSectionName(section, originalIndexOf(section))"
                        (blur)="editSectionName(section, originalIndexOf(section))"
                        (focus)="activeSectionIndex = originalIndexOf(section)"
                        (click)="$event.stopPropagation()"
                    />

                    <span
                        class="ham-icon"
                        (click)="editSectionName(section, originalIndexOf(section))"
                        (click)="$event.stopPropagation()"
                        style="padding-left: 16px; padding-bottom: 4px;"
                    >
                        <i class="edit-icon gray"></i>
                    </span>
                </div>
                <div class="remove-section-button">
                    <ham-button
                        *ngIf="sectionExpanded[originalIndexOf(section)]"
                        size="sm"
                        [outline]="false"
                        variant="transparent"
                        icon="assets/hamIcons/trash-outline.svg"
                        (buttonClick)="openSectionDeletionConfirmationDialog = true; sectionToRemove = section"
                        (click)="$event.stopPropagation()"
                        hideText="true"
                    >
                    </ham-button>
                </div>
                <span class="ham-icon">
                    <i
                        class="chevron-down-icon"
                        [ngClass]="{
                            expanded: sectionExpanded[originalIndexOf(section)],
                            collapsed: sectionExpanded[originalIndexOf(section)]
                        }"
                    ></i>
                </span>
            </div>
            <div
                accordion-body
                cdkDropList
                [cdkDropListData]="getFilteredTaskControls(section)"
                [cdkDropListOrientation]="'vertical'"
                (cdkDropListDropped)="dropTask($event, section)"
            >
                <div
                    class="task"
                    *ngFor="let task of getFilteredTaskControls(section); let j = index"
                    [formGroup]="task"
                    cdkDrag
                    cdkDragLockAxis="y"
                    [cdkDragDisabled]="getFilteredTaskControls(section).length <= 1"
                    (cdkDragMoved)="onDragMoved($event)"
                    (cdkDragEnded)="onDragEnded()"
                >
                    <ng-template cdkDragPreview>
                        <div class="drag-preview-task">
                            {{ task.controls['description'].value || 'aumico_cpmm_task_name' | i18next }}
                        </div>
                    </ng-template>
                    <ng-template cdkDragPlaceholder>
                        <div class="drag-placeholder-task"></div>
                    </ng-template>

                    <ham-button
                        cdkDragHandle
                        size="sm"
                        [outline]="false"
                        variant="transparent"
                        icon="assets/hamIcons/dots-grid.svg"
                        hideText="true"
                    ></ham-button>
                    <input
                        hamInput
                        #taskDescriptionInput
                        [label]="area === 'MANDATE_MANAGEMENT' ? ('aumico_cpmm_task_name' | i18next) : null"
                        [formControl]="task.controls['description']"
                        [placeholder]="'aumico_cpmm_task_description' | i18next"
                        maxlength="250"
                        (keydown)="checkTaskName(task.controls['description'].value)"
                    />
                    <span
                        [ngStyle]="{ 'border-left': area === 'MANDATE_MANAGEMENT' ? '1px solid #E5E7EB' : 'none' }"
                        class="vertical-line"
                    >
                    </span>
                    <div class="task-date-container" *ngIf="area === 'MANDATE_MANAGEMENT'">
                        <div class="period-container">
                            <span class="dynamic-label">
                                {{ 'aumico_cpmm_day_title' | i18next }}
                            </span>
                            <span class="red-star"> * </span>
                            <input
                                hamSimpleDropDown
                                [options]="days"
                                [optionKeys]="['name']"
                                returnKey="id"
                                [returnObject]="true"
                                [placeholder]="'aumico_cpmm_day_placeholder' | i18next"
                                [formControl]="task.controls['scheduleDay']"
                                [ngStyle]="{ width: '100px' }"
                            />
                        </div>
                        <div class="period-container">
                            <span class="dynamic-label">
                                {{ 'aumico_cpmm_month_title' | i18next }}
                            </span>
                            <span class="red-star"> * </span>
                            <input
                                hamSimpleDropDown
                                [options]="months"
                                [optionKeys]="['name']"
                                returnKey="id"
                                [returnObject]="true"
                                [placeholder]="'aumico_cpmm_month_placeholder' | i18next"
                                [formControl]="task.controls['scheduleMonth']"
                            />
                        </div>
                        <div class="period-container">
                            <span class="dynamic-label">
                                {{ 'aumico_cpmm_period_title' | i18next }}
                            </span>
                            <span
                                class="ham-icon period-icon"
                                hamTooltip="{{ 'aumico_cpmm_period_tooltip' | i18next }}"
                                [withArrow]="true"
                                [backGroundHexColor]="'#1F2A37'"
                                [tooltipClass]="'cpmm-period'"
                            >
                                <i class="info-outline-icon"></i>
                            </span>
                            <span class="red-star"> * </span>
                            <input
                                hamSimpleDropDown
                                [options]="periods"
                                [optionKeys]="['name']"
                                returnKey="id"
                                [returnObject]="true"
                                [placeholder]="'aumico_cpmm_period_placeholder' | i18next"
                                [formControl]="task.controls['schedulePeriod']"
                                [ngStyle]="{ width: '200px' }"
                            />
                        </div>
                    </div>
                    <ham-button
                        size="lg"
                        [outline]="false"
                        variant="transparent"
                        icon="assets/hamIcons/minus-outline.svg"
                        (buttonClick)="removeTask(section, j, originalIndexOf(section))"
                        hideText="true"
                    >
                    </ham-button>
                </div>
                <ham-button
                    class="add-task"
                    size="sm"
                    [outline]="true"
                    variant="primary"
                    icon="assets/hamIcons/plus-outline.svg"
                    (buttonClick)="addTask(section)"
                >
                    {{ 'aumico_cpmm_new_task' | i18next }}
                </ham-button>
            </div>
        </ham-accordion-item>
    </ham-accordion>

    <!-- REV-22155: "+ Abschnitt hinzufügen" under the sections, in the look of "Exportieren" (prototype) -->
    <div *ngIf="area === 'MANDATE_MANAGEMENT'" class="add-section-bottom">
        <ham-button
            size="base"
            variant="primary"
            outline="true"
            icon="assets/hamIcons/plus-outline.svg"
            data-testid="configurator-add-section"
            (buttonClick)="addSection()"
        >
            {{ 'aumico_cpmm_add_section' | i18next }}
        </ham-button>
    </div>
</div>

<ham-confirm-decline-modal
    *ngIf="openSectionDeletionConfirmationDialog"
    (cancel)="onCancelSectionDeletion()"
    (action)="removeSection()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_cpmm_closing_workflows_table_delete_section_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    *ngIf="showEmptySectionConfirmationDialog"
    (cancel)="onEmptySectionCancel()"
    (action)="onEmptySectionConfirm()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_cpmm_workflow_configurator_empty_section_confirmation_text' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
